<template>
  <div class="row">
    <div class="container">
      <div class="row">
        <h2>O mnie</h2>
      </div>
      <div v-for="(item, index) in people" v-bind:key="index" class="container">
        <div class="card f">
          <div class="imageContainer">
            <div class="image" :class="item.imageClass">
              <img :src="item.image" :alt="`${item.role} ${item.name}`" />
              <Leafs />
            </div>
          </div>
          <div class="aboutContainer">
            <h2>{{ item.name }}</h2>
            <h3>{{ item.role }}</h3>
            <p v-for="(item, index) in item.paragraphs" v-bind:key="index">
              {{ item }}
            </p>
            <address class="f f-row f-astart">
              <span class="contactInfo" v-if="item.telephone">
                <span>Tel.</span>
                <a href="`tel:${item.telephone}`">{{ item.telephone }}</a>
              </span>
              <span class="contactInfo" v-if="item.email">
                <span>Mail</span>
                <a href="`mailto:${item.email}`">{{ item.email }}</a>
              </span>
            </address>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Leafs from "@/components/svg/Leafs";

export default {
  name: "Us",
  components: {
    Leafs,
  },
  props: {
    people: Array,
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/colors";
@import "../scss/utils";

.container {
  position: relative;
}

.card {
  margin-top: 112px;
  margin-right: auto;
  margin-left: auto;

  @include mobile-s() {
    flex-direction: column;
  }

  .imageContainer {
    flex: 1;
  }

  .aboutContainer {
    flex: 1.6;
  }

  .image {
    margin-right: 32px;

    img {
      width: 100%;
      height: auto;
    }

    &.right {
      right: 20px;

      .Leafs {
        right: 100%;
        transform: translate(50%, -50%) rotate(90deg) scale(1.1);
      }
    }

    &.left {
      left: 20px;

      .Leafs {
        right: 0;
        transform: translate(-50%, -50%) scale(1.1);
      }
    }

    .Leafs,
    & #Warstwa_1 {
      opacity: 0.4;
      position: absolute;
      width: 70%;
      height: 100%;
      top: 100%;
    }
  }

  @include mobile() {
    margin-top: 20px;

    .image {
      bottom: 100%;
      top: auto;
    }
  }
}

address {
  span {
    text-align: left;
    margin-bottom: 5px;
    font-size: 13px;
    font-style: normal;
  }

  .contactInfo {
    span {
      min-width: 30px;
      display: inline-block;
    }
  }
}

p,
h3 {
  margin-bottom: 10px;
}

h2 {
  font-size: 16px;
}

h3 {
  margin-top: -12px;
  font-size: 14px;
}
</style>
